import { render, staticRenderFns } from "./DiscountCodeList.vue?vue&type=template&id=b97999c8"
import script from "./DiscountCodeList.vue?vue&type=script&lang=js"
export * from "./DiscountCodeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports